import i18next from "i18next";
import {
  AUTH_EMAIL_ALREADY_EXISTS,
  AUTH_INVALID_PASSWORD,
  AUTH_MANY_REQUESTS,
  AUTH_USER_NOT_FOUND,
  AUTH_WRONG_PASSWORD,
  ERROR_INTERNAL,
  FIELD_EMAIL_VALID,
  STRIPE_CARD_DECLINED,
  STRIPE_EXPIRED_CARD,
  STRIPE_INCORRECT_CVC,
  STRIPE_PROCESSING_ERROR,
  STRIPE_INCORRECT_NUMBER,
  STRIPE_GENERIC_DECLINE,
  STRIPE_INSUFFICIENT_FUNDS,
  STRIPE_LOST_CARD,
  STRIPE_STOLEN_CARD,
  STRIPE_PROFILE_NOT_FOUND,
  STRIPE_INTENT_AUTH_FAILURE,
  NIT_VALID,
  BUSINESS_NAME_VALID,
  BRAND_NAME_VALID,
  ADDRESS_VALID,
  CATEGORY_VALID,
  SUBCATEGORIES_VALID,
  SHORT_DESCRIPTION_VALID,
  ORDERS_METHODS_VALID,
  LOGO_IMG_VALID,
  COVER_IMG_VALID,
  SCHEDULE_VALID,
  STORES_VALID,
  IS_PLAN_ACTIVE_VALID,
  MENUS_VALID,
  DEFAULT_PAYMENT_METHOD_VALID,
  HAS_DEBT_VALID,
  SUBSCRIPTION_PLAN_VALID,
  MISSING_PARAMETERS,
  PASSWORD_INVALID,
  INVALID_SEARCH,
  USER_ID_REQUIRED,
  SHOP_ID_REQUIRED,
  LAST_USER_NOT_DELETED,
  PLAN_TRIAL_USER_USED,
  ORDERS_NOT_FOUND_IN_INTERVAL,
  TYPE_REPORT_NOT_FOUND,
  SHOP_NOT_FOUND,
  PAYMENT_MODEL_INVALID,
  SHOP_NOT_HAS_SOCIAL_NETWORK,
  NO_VALID_PLATFORM_FOUND,
  GETTING_STATISTICS,
  SHOP_BUSINESS_NAME_NOT_FOUND,
  REFERENCE_PROFILES_REQUIRED,
  DECRYPTING_PASSWORD,
  USER_ID_AND_PAYMENT_ID,
  MESSAGES_REQUIRED,
  PLAN_IS_NO_ACTIVE,
  USER_BANNED,
  GETTING_LOCALES,
  GETTING_PROFILE,
  PRODUCTS_NOT_SENT,
  ACCOUNT_NOT_FOUND,
  COLLECTING_INFORMATION_RETRY_AFTER,
  ERROR_OCCURRED,
  PLATFORM_NOT_SENT,
  PLATFORM_APP_REQUEST_LIMIT_REACHED,
  VERIFICATION_CODE_NOT_FOUND,
  ORDER_NOT_FOUND,
  TYPE_OR_PATH_NOT_SENT,
  ID_OR_PATH_NOT_SENT,
  IDS_NOT_SENT,
  ANALYTIC_URL_NOT_SENT,
  ANALYTIC_URL_INVALID,
  EXTRACTING_ANALYTICS,
  CREDENTIALS_INVALID,
  COLLABORATION_PRICE_NOT_BE_NEGATIVE,
  CREDITS_NOT_BE_NEGATIVE,
  PACKAGES_PRICES_NOT_BE_NEGATIVE,
  ROL_REQUIRED,
  SHOP_ID_AND_STORE_ID_REQUIRED,
  PASSWORD_MUST_BE_6_CHARACTERS,
  ALL_USERS_NOT_DELETE,
  SHOP_APPLICANT_NOT_FOUND,
  USER_PASSWORD_NOT_FOUND,
  PLAN_NOT_FOUND,
  SUBSCRIPTION_NOT_CREATED,
  ID_SUBSCRIPTION_NOT_FOUND,
  SUBSCRIPTION_REACTIVATE,
  CUSTOMER_ID_NOT_FOUND,
  APPLICANT_NOT_FOUND,
  SHOP_COUNTRY_NOT_FOUND,
  FINAL_PRICE_NOT_FOUND,
  PAYMENT_FAILED,
  PHONE_ALREADY_REGISTERED,
  CREDITS_MUST_BE_GREATER_THAN_ZERO,
  CSRF_INVALID,
  INTEGRATION_INFORMATION_NOT_FOUND,
  GETTING_VIDEO,
  UPLOAD_URL_NOT_FOUND,
  UPLOADING_VIDEO,
  STORE_NOT_FOUND,
  NAME_REQUIRED,
  PRICE_REQUIRED,
  CURRENCY_REQUIRED,
  RECURRING_REQUIRED,
  CREATING_PRODUCT,
  CREATING_PRICE,
  CREATING_PAYMENT_LINK,
  GETTING_PAYMENT_LINK,
  TOKEN_INVALID,
  TOKEN_EXPIRED,
  IG_ACCOUNT_NOT_FOUND,
  IG_DATA_NOT_FOUND,
  REVIEW_NOT_FOUND,
  REVIEW_IS_NOT_ONE_START,
  DISSATISFACTION_CREDIT_ALREADY_EXISTS,
  META_INTEGRATION_UNLINKED_PAGES_ERROR,
  PAYMENT_METHOD_NOT_FOUND,
  HAS_PENDING_PAYMENTS,
  NO_IMAGES_FOUND_ON_PAGE,
  NO_CREATE_DISCOUNT_SHOPIFY,
  NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY,
  NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY,
  NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY,
  GETTING_INFORMATION_FROM_SHOPIFY_URL,
  RATE_DAILY_LIMIT_AI,
  PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META,
  ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS,
  FACEBOOK_PAGE_ID_NOT_FOUND,
  META_BUSINESS_ACCOUNT_NOT_FOUND,
  IG_BUSINESS_ACCOUNT_NOT_FOUND,
  ACCOUNT_TIKTOK_AUTH_NOT_MATCH,
  ACCOUNT_TOKEN_META_NOT_FOUND,
  ACCOUNT_ID_BUSINESS_META_NOT_FOUND,
  OBJECTIVE_CAMPAIGN_META_INVALID,
  SPECIAL_CATEGORY_CAMPAIGN_META_INVALID,
  CAMPAIGN_META_NOT_DELETED,
  CAMPAIGN_META_NOT_CREATED,
  ADS_CAMPAIGN_NOT_FOUND,
  NO_PIXELS_FOUND,
  NO_PIXELS_ACTIVE,
  CAMPAIGN_META_NOT_FOUND,
  CAMPAIGN_META_NOT_UPDATED,
  CAMPAIGN_AD_SET_META_NOT_CREATED,
  CAMPAIGN_AD_SET_META_NOT_UPDATED,
  CAMPAIGN_MEDIA_META_NOT_CREATED,
  CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND,
  CAMPAIGN_CREATIVE_AD_META_NOT_CREATED,
  CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED,
  CAMPAIGN_CREATIVE_AD_META_NOT_FOUND,
  CAMPAIGN_AD_META_NOT_CREATED,
  CAMPAIGN_AD_META_NOT_UPDATED,
  CAMPAIGN_METRICS_META_NOT_FOUND,
  CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  CAMPAIGN_AUDIENCE_IS_TOO_NARROW,
  CAMPAIGN_BUDGET_IS_TOO_LOW,
  IDENTITY_NOT_FOUND,
  VIDEO_ERROR_LOW_RESOLUTION,
  VIDEO_ERROR_NO_BACKGROUND_AUDIO,
  VIDEO_ERROR_ASPECT_RATIO,
  VIDEO_ERROR_BLACK_EDGE,
  VIDEO_ERROR_ILLEGAL_DURATION,
  AUTH_INVALID_VERIFICATION_CODE,
  ERROR_GETTING_URL_INFORMATION_BY_PROTECTED,
  ERROR,
  AUTH_INVALID_APP_CREDENTIAL,
  META_AD_ACCOUNT_IS_NOT_ACTIVE,
  META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD,
  ADVERTISER_ID_NOT_FOUND_TIK_TOK,
  ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK,
  ADVERTISERS_LIMIT_REACHED,
  ACCOUNT_ROLE_INVALID,
  ERROR_GETTING_URL_META_DATA_AND_IMAGES,
  ADVERTISER_ID_TO_CHANGE_NO_PERMISSION,
  CANNOT_DELETE_MAIN_ADVERTISER,
  SCRIPT_IS_TOO_SHORT,
  WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED,
  EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM,
  OAUTH_IN_WINDOW_NO_COMPLETED,
  ERROR_PROCESSING_REQUEST,
  NOT_HAVE_ENOUGH_USAGE_VALUE,
  NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE,
  BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN,
  BRAND_USAGE_ALLOCATION_BELOW_CONSUMED,
  ERROR_NETWORK_CONNECTION,
  REQUEST_TIME_OUT,
  TIME_OUT_FOR_PROVIDER,
  FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER,
  YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP,
  ERROR_DESCRIPTION_GENERIC,
  META_ERROR_GETTING_USER_INFORMATION,
  META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION,
  META_ERROR_GETTING_ACCOUNTS_INFORMATION,
  ERROR_WITH_MOBILE_PROVIDER,
  ADVERTISER_ID_NOT_FOUND_GOOGLE,
  ERROR_CREATING_INSTANT_EXPERIENCE,
  CAMPAIGN_REQUEST_ABORTED,
  APP_URL_NOT_FOUND,
  CAMPAIGN_ALREADY_BEING_CREATED,
  CAMPAIGN_ALREADY_BEING_UPDATED,
  INVALID_APP_DEEP_LINK,
  GENERATION_VIDEO_REJECTED,
  AI_PROVIDER_CREDENTIALS_INVALID,
  AI_PROVIDER_CREDENTIALS_INVALID_GENERIC,
  AI_REQUEST_TIMEOUT,
  FAL_AI_CREDENTIALS_INVALID,
  HEYGEN_CREDENTIALS_INVALID,
  IMAGES_MODERATION_BLOCKED,
  MALFORMED_FUNCTION_CALL,
  WARNING,
  INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW,
  BENEFICIARY_OR_PAYER_NOT_FOUND,
  META_OAUTH_PERMISSIONS_ERROR,
  META_ACCOUNT_AUTHENTICATION_REQUIRED,
  DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN,
  LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED,
  CAMPAIGN_IS_GENERATING,
  INVALID_JOB_TYPE,
  JOB_CANCELLED_OR_FAILED,
  JOB_TIMEOUT,
  CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD,
  VERIFICATION_CODE_INCORRECT,
  REGISTRATION_EMAIL_NOT_VERIFIED,
  PROMOTIONAL_CODE_NOT_FOUND,
  PROMOTIONAL_CODE_INACTIVE,
  PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED,
  VIDEO_GENERATION_FAILED_BY_PROVIDER,
  AI_RATE_LIMITED,
  AI_PROVIDER_UNAVAILABLE,
  AI_GENERATION_FAILED,
  CREDITS_RETURNED_SUFFIX,
  CREATIVE_UNEXPECTED_IMAGE_PROVIDER_ERROR,
  CREATIVE_UNEXPECTED_VIDEO_PROVIDER_ERROR,
  CREATIVE_UNEXPECTED_AI_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_IMAGE_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_VIDEO_PROVIDER_ERROR,
  CREATIVE_TIMEOUT_AI_PROVIDER_ERROR,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS,
  APP_SUMO_REACTIVATION_NOT_ELIGIBLE,
} from "../i18n/keysTranslations";
import { BYOK_PROVIDERS_BY_ID } from "./byokProviderCatalog";
import { getObjectError } from "./string";
import {
  RESIZE_MAX_EDGE,
  RESIZE_MAX_PIXELS,
  RESIZE_MIN_PIXELS,
} from "./resizeCustomDimensions";
import { SimpleAlert } from "../components/Alerts/Alerts";
import {
  ALERT_ICON_TYPE_ERROR,
  ALERT_ICON_TYPE_INFO,
  FONT_FAMILY,
} from "./constants";
import Typography from "@mui/material/Typography";
import {
  setShowModalSelectSubscription,
  showBrandUsageLimitAlert,
} from "../actions/ui";
import { openIntegrationNotFoundModalIfNeeded } from "../actions/alerts";
import * as Sentry from "@sentry/react";

/** Detecta errores de red que pueden recuperarse con retry (Firebase auth/network-request-failed, axios ERR_NETWORK) */
export const isNetworkError = (error) => {
  if (!error) return false;
  const code = error?.code;
  const message = error?.message?.toLowerCase?.() || "";
  return (
    code === "auth/network-request-failed" ||
    code === "ERR_NETWORK" ||
    message === "network error"
  );
};

export const isAbortError = (error) => {
  return (
    error?.name === "AbortError" ||
    error?.code === "ERR_CANCELED" ||
    error?.name === "CanceledError" ||
    error?.message === "canceled"
  );
};

const errorsObject = {
  "auth/invalid-email": FIELD_EMAIL_VALID,
  "auth/internal-error": ERROR_INTERNAL,
  "auth/invalid-password": AUTH_INVALID_PASSWORD,
  "auth/wrong-password": AUTH_WRONG_PASSWORD,
  "auth/too-many-requests": AUTH_MANY_REQUESTS,
  "auth/user-not-found": AUTH_USER_NOT_FOUND,
  "auth/email-already-exists": AUTH_EMAIL_ALREADY_EXISTS,
  "auth/invalid-verification-code": AUTH_INVALID_VERIFICATION_CODE,
  "auth/visibility-check-was-unavailable.-please-retry-the-request-and-contact-support-if-the-problem-persists":
    ERROR_OCCURRED,
  "auth/invalid-app-credential": AUTH_INVALID_APP_CREDENTIAL,
  "auth/popup-closed-by-user": OAUTH_IN_WINDOW_NO_COMPLETED,
  "auth/network-request-failed": ERROR_NETWORK_CONNECTION,
  "auth/quota-exceeded": REQUEST_TIME_OUT,
  "auth/error-code:-39": ERROR_WITH_MOBILE_PROVIDER,
  "auth/operation-not-allowed": ERROR_WITH_MOBILE_PROVIDER,
  ERR_NETWORK: ERROR_NETWORK_CONNECTION,
  card_declined: STRIPE_CARD_DECLINED,
  expired_card: STRIPE_EXPIRED_CARD,
  incorrect_cvc: STRIPE_INCORRECT_CVC,
  processing_error: STRIPE_PROCESSING_ERROR,
  incorrect_number: STRIPE_INCORRECT_NUMBER,
  generic_decline: STRIPE_GENERIC_DECLINE,
  insufficient_funds: STRIPE_INSUFFICIENT_FUNDS,
  lost_card: STRIPE_LOST_CARD,
  stolen_card: STRIPE_STOLEN_CARD,
  profile_not_found: STRIPE_PROFILE_NOT_FOUND,
  payment_intent_authentication_failure: STRIPE_INTENT_AUTH_FAILURE,
  [MISSING_PARAMETERS]: MISSING_PARAMETERS,
  [PASSWORD_INVALID]: PASSWORD_INVALID,
  [INVALID_SEARCH]: INVALID_SEARCH,
  [USER_ID_REQUIRED]: USER_ID_REQUIRED,
  [SHOP_ID_REQUIRED]: SHOP_ID_REQUIRED,
  [LAST_USER_NOT_DELETED]: LAST_USER_NOT_DELETED,
  [PLAN_TRIAL_USER_USED]: PLAN_TRIAL_USER_USED,
  [ORDERS_NOT_FOUND_IN_INTERVAL]: ORDERS_NOT_FOUND_IN_INTERVAL,
  [TYPE_REPORT_NOT_FOUND]: TYPE_REPORT_NOT_FOUND,
  [SHOP_NOT_FOUND]: SHOP_NOT_FOUND,
  [PAYMENT_MODEL_INVALID]: PAYMENT_MODEL_INVALID,
  [SHOP_NOT_HAS_SOCIAL_NETWORK]: SHOP_NOT_HAS_SOCIAL_NETWORK,
  [NO_VALID_PLATFORM_FOUND]: NO_VALID_PLATFORM_FOUND,
  [GETTING_STATISTICS]: GETTING_STATISTICS,
  [SHOP_BUSINESS_NAME_NOT_FOUND]: SHOP_BUSINESS_NAME_NOT_FOUND,
  [REFERENCE_PROFILES_REQUIRED]: REFERENCE_PROFILES_REQUIRED,
  [DECRYPTING_PASSWORD]: DECRYPTING_PASSWORD,
  [USER_ID_AND_PAYMENT_ID]: USER_ID_AND_PAYMENT_ID,
  [MESSAGES_REQUIRED]: MESSAGES_REQUIRED,
  [PLAN_IS_NO_ACTIVE]: PLAN_IS_NO_ACTIVE,
  [USER_BANNED]: USER_BANNED,
  [GETTING_LOCALES]: GETTING_LOCALES,
  [GETTING_PROFILE]: GETTING_PROFILE,
  [PRODUCTS_NOT_SENT]: PRODUCTS_NOT_SENT,
  [ACCOUNT_NOT_FOUND]: ACCOUNT_NOT_FOUND,
  [COLLECTING_INFORMATION_RETRY_AFTER]: COLLECTING_INFORMATION_RETRY_AFTER,
  [ERROR_OCCURRED]: ERROR_OCCURRED,
  [PLATFORM_NOT_SENT]: PLATFORM_NOT_SENT,
  [PLATFORM_APP_REQUEST_LIMIT_REACHED]: PLATFORM_APP_REQUEST_LIMIT_REACHED,
  [VERIFICATION_CODE_NOT_FOUND]: VERIFICATION_CODE_NOT_FOUND,
  [ORDER_NOT_FOUND]: ORDER_NOT_FOUND,
  [TYPE_OR_PATH_NOT_SENT]: TYPE_OR_PATH_NOT_SENT,
  [ID_OR_PATH_NOT_SENT]: ID_OR_PATH_NOT_SENT,
  [IDS_NOT_SENT]: IDS_NOT_SENT,
  [ANALYTIC_URL_NOT_SENT]: ANALYTIC_URL_NOT_SENT,
  [ANALYTIC_URL_INVALID]: ANALYTIC_URL_INVALID,
  [EXTRACTING_ANALYTICS]: EXTRACTING_ANALYTICS,
  [CREDENTIALS_INVALID]: CREDENTIALS_INVALID,
  [COLLABORATION_PRICE_NOT_BE_NEGATIVE]: COLLABORATION_PRICE_NOT_BE_NEGATIVE,
  [CREDITS_NOT_BE_NEGATIVE]: CREDITS_NOT_BE_NEGATIVE,
  [PACKAGES_PRICES_NOT_BE_NEGATIVE]: PACKAGES_PRICES_NOT_BE_NEGATIVE,
  [ROL_REQUIRED]: ROL_REQUIRED,
  [SHOP_ID_AND_STORE_ID_REQUIRED]: SHOP_ID_AND_STORE_ID_REQUIRED,
  [PASSWORD_MUST_BE_6_CHARACTERS]: PASSWORD_MUST_BE_6_CHARACTERS,
  [ALL_USERS_NOT_DELETE]: ALL_USERS_NOT_DELETE,
  [SHOP_APPLICANT_NOT_FOUND]: SHOP_APPLICANT_NOT_FOUND,
  [USER_PASSWORD_NOT_FOUND]: USER_PASSWORD_NOT_FOUND,
  [PLAN_NOT_FOUND]: PLAN_NOT_FOUND,
  [SUBSCRIPTION_NOT_CREATED]: SUBSCRIPTION_NOT_CREATED,
  [ID_SUBSCRIPTION_NOT_FOUND]: ID_SUBSCRIPTION_NOT_FOUND,
  [SUBSCRIPTION_REACTIVATE]: SUBSCRIPTION_REACTIVATE,
  [CUSTOMER_ID_NOT_FOUND]: CUSTOMER_ID_NOT_FOUND,
  [APPLICANT_NOT_FOUND]: APPLICANT_NOT_FOUND,
  [SHOP_COUNTRY_NOT_FOUND]: SHOP_COUNTRY_NOT_FOUND,
  [FINAL_PRICE_NOT_FOUND]: FINAL_PRICE_NOT_FOUND,
  [PAYMENT_FAILED]: PAYMENT_FAILED,
  [PHONE_ALREADY_REGISTERED]: PHONE_ALREADY_REGISTERED,
  [CREDITS_MUST_BE_GREATER_THAN_ZERO]: CREDITS_MUST_BE_GREATER_THAN_ZERO,
  [CSRF_INVALID]: CSRF_INVALID,
  [INTEGRATION_INFORMATION_NOT_FOUND]: INTEGRATION_INFORMATION_NOT_FOUND,
  [GETTING_VIDEO]: GETTING_VIDEO,
  [UPLOAD_URL_NOT_FOUND]: UPLOAD_URL_NOT_FOUND,
  [UPLOADING_VIDEO]: UPLOADING_VIDEO,
  [STORE_NOT_FOUND]: STORE_NOT_FOUND,
  [NAME_REQUIRED]: NAME_REQUIRED,
  [PRICE_REQUIRED]: PRICE_REQUIRED,
  [CURRENCY_REQUIRED]: CURRENCY_REQUIRED,
  [RECURRING_REQUIRED]: RECURRING_REQUIRED,
  [CREATING_PRODUCT]: CREATING_PRODUCT,
  [CREATING_PRICE]: CREATING_PRICE,
  [CREATING_PAYMENT_LINK]: CREATING_PAYMENT_LINK,
  [GETTING_PAYMENT_LINK]: GETTING_PAYMENT_LINK,
  [TOKEN_INVALID]: TOKEN_INVALID,
  [TOKEN_EXPIRED]: TOKEN_EXPIRED,
  [IG_ACCOUNT_NOT_FOUND]: IG_ACCOUNT_NOT_FOUND,
  [IG_DATA_NOT_FOUND]: IG_DATA_NOT_FOUND,
  [REVIEW_NOT_FOUND]: REVIEW_NOT_FOUND,
  [REVIEW_IS_NOT_ONE_START]: REVIEW_IS_NOT_ONE_START,
  [DISSATISFACTION_CREDIT_ALREADY_EXISTS]:
    DISSATISFACTION_CREDIT_ALREADY_EXISTS,
  [META_INTEGRATION_UNLINKED_PAGES_ERROR]:
    META_INTEGRATION_UNLINKED_PAGES_ERROR,
  [PAYMENT_METHOD_NOT_FOUND]: PAYMENT_METHOD_NOT_FOUND,
  [HAS_PENDING_PAYMENTS]: HAS_PENDING_PAYMENTS,
  [NO_IMAGES_FOUND_ON_PAGE]: NO_IMAGES_FOUND_ON_PAGE,
  [NO_CREATE_DISCOUNT_SHOPIFY]: NO_CREATE_DISCOUNT_SHOPIFY,
  [NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY]:
    NO_CREATE_WEBHOOK_ORDER_CREATED_SHOPIFY,
  [NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY]:
    NO_CREATE_WEBHOOK_FULFILLMENT_CREATED_SHOPIFY,
  [NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY]:
    NO_CREATE_WEBHOOK_FULFILLMENT_UPDATED_SHOPIFY,
  [GETTING_INFORMATION_FROM_SHOPIFY_URL]: GETTING_INFORMATION_FROM_SHOPIFY_URL,
  [RATE_DAILY_LIMIT_AI]: RATE_DAILY_LIMIT_AI,
  [PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META]:
    PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META,
  [ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS]:
    ACCOUNT_IS_NOT_TYPE_BUSINESS_OR_NO_ACCEPTED_ALL_PERMISSIONS,
  [FACEBOOK_PAGE_ID_NOT_FOUND]: FACEBOOK_PAGE_ID_NOT_FOUND,
  [META_BUSINESS_ACCOUNT_NOT_FOUND]: META_BUSINESS_ACCOUNT_NOT_FOUND,
  [IG_BUSINESS_ACCOUNT_NOT_FOUND]: IG_BUSINESS_ACCOUNT_NOT_FOUND,
  [ACCOUNT_TIKTOK_AUTH_NOT_MATCH]: ACCOUNT_TIKTOK_AUTH_NOT_MATCH,
  [ACCOUNT_TOKEN_META_NOT_FOUND]: ACCOUNT_TOKEN_META_NOT_FOUND,
  [ACCOUNT_ID_BUSINESS_META_NOT_FOUND]: ACCOUNT_ID_BUSINESS_META_NOT_FOUND,
  [OBJECTIVE_CAMPAIGN_META_INVALID]: OBJECTIVE_CAMPAIGN_META_INVALID,
  [SPECIAL_CATEGORY_CAMPAIGN_META_INVALID]:
    SPECIAL_CATEGORY_CAMPAIGN_META_INVALID,
  [CAMPAIGN_META_NOT_DELETED]: CAMPAIGN_META_NOT_DELETED,
  [CAMPAIGN_META_NOT_CREATED]: CAMPAIGN_META_NOT_CREATED,
  [ADS_CAMPAIGN_NOT_FOUND]: ADS_CAMPAIGN_NOT_FOUND,
  [NO_PIXELS_FOUND]: NO_PIXELS_FOUND,
  [NO_PIXELS_ACTIVE]: NO_PIXELS_ACTIVE,
  [CAMPAIGN_META_NOT_FOUND]: CAMPAIGN_META_NOT_FOUND,
  [CAMPAIGN_META_NOT_UPDATED]: CAMPAIGN_META_NOT_UPDATED,
  [CAMPAIGN_AD_SET_META_NOT_CREATED]: CAMPAIGN_AD_SET_META_NOT_CREATED,
  [CAMPAIGN_AD_SET_META_NOT_UPDATED]: CAMPAIGN_AD_SET_META_NOT_UPDATED,
  [CAMPAIGN_MEDIA_META_NOT_CREATED]: CAMPAIGN_MEDIA_META_NOT_CREATED,
  [CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND]:
    CAMPAIGN_MEDIA_THUMBNAIL_META_NOT_FOUND,
  [CAMPAIGN_CREATIVE_AD_META_NOT_CREATED]:
    CAMPAIGN_CREATIVE_AD_META_NOT_CREATED,
  [CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED]:
    CAMPAIGN_CREATIVE_AD_META_NOT_UPDATED,
  [CAMPAIGN_CREATIVE_AD_META_NOT_FOUND]: CAMPAIGN_CREATIVE_AD_META_NOT_FOUND,
  [CAMPAIGN_AD_META_NOT_CREATED]: CAMPAIGN_AD_META_NOT_CREATED,
  [CAMPAIGN_AD_META_NOT_UPDATED]: CAMPAIGN_AD_META_NOT_UPDATED,
  [CAMPAIGN_METRICS_META_NOT_FOUND]: CAMPAIGN_METRICS_META_NOT_FOUND,
  [ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE]:
    ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  [CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE]:
    CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  [CAMPAIGN_AUDIENCE_IS_TOO_NARROW]: CAMPAIGN_AUDIENCE_IS_TOO_NARROW,
  [CAMPAIGN_BUDGET_IS_TOO_LOW]: CAMPAIGN_BUDGET_IS_TOO_LOW,
  [IDENTITY_NOT_FOUND]: IDENTITY_NOT_FOUND,
  [VIDEO_ERROR_LOW_RESOLUTION]: VIDEO_ERROR_LOW_RESOLUTION,
  [VIDEO_ERROR_NO_BACKGROUND_AUDIO]: VIDEO_ERROR_NO_BACKGROUND_AUDIO,
  [VIDEO_ERROR_ASPECT_RATIO]: VIDEO_ERROR_ASPECT_RATIO,
  [VIDEO_ERROR_BLACK_EDGE]: VIDEO_ERROR_BLACK_EDGE,
  [VIDEO_ERROR_ILLEGAL_DURATION]: VIDEO_ERROR_ILLEGAL_DURATION,
  [ERROR_GETTING_URL_INFORMATION_BY_PROTECTED]:
    ERROR_GETTING_URL_INFORMATION_BY_PROTECTED,
  [META_AD_ACCOUNT_IS_NOT_ACTIVE]: META_AD_ACCOUNT_IS_NOT_ACTIVE,
  [META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD]:
    META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD,
  [ADVERTISER_ID_NOT_FOUND_TIK_TOK]: ADVERTISER_ID_NOT_FOUND_TIK_TOK,
  [ADVERTISER_ID_NOT_FOUND_GOOGLE]: ADVERTISER_ID_NOT_FOUND_GOOGLE,
  [ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK]:
    ADVERTISER_CURRENCY_NOT_FOUND_TIK_TOK,
  [ADVERTISERS_LIMIT_REACHED]: ADVERTISERS_LIMIT_REACHED,
  [NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE]: NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE,
  [BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN]: BRAND_USAGE_ALLOCATION_EXCEEDS_PLAN,
  [BRAND_USAGE_ALLOCATION_BELOW_CONSUMED]:
    BRAND_USAGE_ALLOCATION_BELOW_CONSUMED,
  [ACCOUNT_ROLE_INVALID]: ACCOUNT_ROLE_INVALID,
  [ERROR_GETTING_URL_META_DATA_AND_IMAGES]:
    ERROR_GETTING_URL_META_DATA_AND_IMAGES,
  [ADVERTISER_ID_TO_CHANGE_NO_PERMISSION]:
    ADVERTISER_ID_TO_CHANGE_NO_PERMISSION,
  [CANNOT_DELETE_MAIN_ADVERTISER]: CANNOT_DELETE_MAIN_ADVERTISER,
  [SCRIPT_IS_TOO_SHORT]: SCRIPT_IS_TOO_SHORT,
  [WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED]:
    WEBSITE_AND_SOCIAL_NETWORK_CANT_ANALYZED,
  [EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM]:
    EMAIL_PROVIDER_IS_NOT_EQUAL_TO_EMAIL_FORM,
  [ERROR_PROCESSING_REQUEST]: ERROR_PROCESSING_REQUEST,
  [ERROR_NETWORK_CONNECTION]: ERROR_NETWORK_CONNECTION,
  [REQUEST_TIME_OUT]: REQUEST_TIME_OUT,
  [TIME_OUT_FOR_PROVIDER]: TIME_OUT_FOR_PROVIDER,
  [FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER]:
    FACEBOOK_PAGE_NEED_CONNECTED_WHATSAPP_NUMBER,
  [YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP]:
    YOUR_FACEBOOK_PAGE_MUST_BE_IN_BUSINESS_PORTFOLIO_OWN_WHATSAPP,
  [META_ERROR_GETTING_USER_INFORMATION]: META_ERROR_GETTING_USER_INFORMATION,
  [META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION]:
    META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION,
  [META_ERROR_GETTING_ACCOUNTS_INFORMATION]:
    META_ERROR_GETTING_ACCOUNTS_INFORMATION,
  [ERROR_CREATING_INSTANT_EXPERIENCE]: ERROR_CREATING_INSTANT_EXPERIENCE,
  [CAMPAIGN_REQUEST_ABORTED]: CAMPAIGN_REQUEST_ABORTED,
  [APP_URL_NOT_FOUND]: APP_URL_NOT_FOUND,
  [CAMPAIGN_ALREADY_BEING_CREATED]: CAMPAIGN_ALREADY_BEING_CREATED,
  [CAMPAIGN_ALREADY_BEING_UPDATED]: CAMPAIGN_ALREADY_BEING_UPDATED,
  [INVALID_APP_DEEP_LINK]: INVALID_APP_DEEP_LINK,
  [GENERATION_VIDEO_REJECTED]: GENERATION_VIDEO_REJECTED,
  [AI_PROVIDER_CREDENTIALS_INVALID]: AI_PROVIDER_CREDENTIALS_INVALID,
  [FAL_AI_CREDENTIALS_INVALID]: AI_PROVIDER_CREDENTIALS_INVALID,
  [HEYGEN_CREDENTIALS_INVALID]: AI_PROVIDER_CREDENTIALS_INVALID,
  [AI_REQUEST_TIMEOUT]: AI_REQUEST_TIMEOUT,
  [IMAGES_MODERATION_BLOCKED]: IMAGES_MODERATION_BLOCKED,
  [MALFORMED_FUNCTION_CALL]: MALFORMED_FUNCTION_CALL,
  [VIDEO_GENERATION_FAILED_BY_PROVIDER]: VIDEO_GENERATION_FAILED_BY_PROVIDER,
  [AI_RATE_LIMITED]: AI_RATE_LIMITED,
  [AI_PROVIDER_UNAVAILABLE]: AI_PROVIDER_UNAVAILABLE,
  [AI_GENERATION_FAILED]: AI_GENERATION_FAILED,
  [MALFORMED_FUNCTION_CALL]: MALFORMED_FUNCTION_CALL,
  [AI_RATE_LIMITED]: AI_RATE_LIMITED,
  [AI_PROVIDER_UNAVAILABLE]: AI_PROVIDER_UNAVAILABLE,
  [AI_GENERATION_FAILED]: AI_GENERATION_FAILED,
  [VIDEO_GENERATION_FAILED_BY_PROVIDER]: VIDEO_GENERATION_FAILED_BY_PROVIDER,
  [INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW]:
    INVALID_UPDATE_STATUS_CREATIVE_IN_REVIEW,
  [BENEFICIARY_OR_PAYER_NOT_FOUND]: BENEFICIARY_OR_PAYER_NOT_FOUND,
  [META_OAUTH_PERMISSIONS_ERROR]: META_OAUTH_PERMISSIONS_ERROR,
  [META_ACCOUNT_AUTHENTICATION_REQUIRED]: META_ACCOUNT_AUTHENTICATION_REQUIRED,
  [DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN]:
    DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN,
  [LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED]:
    LINKEDIN_PARTNERSHIP_CREDITS_ALREADY_CLAIMED,
  [CAMPAIGN_IS_GENERATING]: CAMPAIGN_IS_GENERATING,
  [INVALID_JOB_TYPE]: INVALID_JOB_TYPE,
  [JOB_CANCELLED_OR_FAILED]: JOB_CANCELLED_OR_FAILED,
  [JOB_TIMEOUT]: JOB_TIMEOUT,
  [CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD]:
    CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD,
  [VERIFICATION_CODE_INCORRECT]: VERIFICATION_CODE_INCORRECT,
  [REGISTRATION_EMAIL_NOT_VERIFIED]: REGISTRATION_EMAIL_NOT_VERIFIED,
  [PROMOTIONAL_CODE_NOT_FOUND]: PROMOTIONAL_CODE_NOT_FOUND,
  [PROMOTIONAL_CODE_INACTIVE]: PROMOTIONAL_CODE_INACTIVE,
  [PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED]:
    PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED,
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID]:
    IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID,
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16]:
    IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16,
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16]:
    IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16,
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED]:
    IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED,
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED]:
    IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED,
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS]:
    IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS,
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS]:
    IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS,
  PROMOTIONAL_CODE_NOT_FOUND: PROMOTIONAL_CODE_NOT_FOUND,
  PROMOTIONAL_CODE_INACTIVE: PROMOTIONAL_CODE_INACTIVE,
  PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED:
    PROMOTIONAL_CODE_MAX_REDEMPTIONS_REACHED,
  [APP_SUMO_REACTIVATION_NOT_ELIGIBLE]: APP_SUMO_REACTIVATION_NOT_ELIGIBLE,
};

const LEGACY_PROVIDER_LABELS_BY_ERROR_CODE = {
  [FAL_AI_CREDENTIALS_INVALID]: "Fal AI",
  [HEYGEN_CREDENTIALS_INVALID]: "HeyGen",
};

export const resolveProviderLabelForError = (providerId) =>
  BYOK_PROVIDERS_BY_ID[providerId]?.label || providerId || "AI";

export const getProviderInterpolationForError = (errorCode, providerId) => {
  if (providerId) {
    return { provider: resolveProviderLabelForError(providerId) };
  }

  const legacyProvider = LEGACY_PROVIDER_LABELS_BY_ERROR_CODE[errorCode];
  if (legacyProvider) {
    return { provider: legacyProvider };
  }

  return {};
};

export const CREATIVE_JOB_TYPES = {
  generateImages: "generateImages",
  resizeImage: "resizeImage",
  editImage: "editImage",
  editImagesBatch: "editImagesBatch",
  resizeImagesBatch: "resizeImagesBatch",
  animateImage: "animateImage",
  generateVideo: "generateVideo",
  generateRecommendedSettingsPlatform: "generateRecommendedSettingsPlatform",
  generateCustomReport: "generateCustomReport",
  analyzeImageLayers: "analyzeImageLayers",
  analyzeCreativeTemplate: "analyzeCreativeTemplate",
  produceCreativeTemplate: "produceCreativeTemplate",
};

const CREATIVE_JOB_CATEGORY = {
  [CREATIVE_JOB_TYPES.generateImages]: "image",
  [CREATIVE_JOB_TYPES.resizeImage]: "image",
  [CREATIVE_JOB_TYPES.editImage]: "image",
  [CREATIVE_JOB_TYPES.editImagesBatch]: "image",
  [CREATIVE_JOB_TYPES.resizeImagesBatch]: "image",
  [CREATIVE_JOB_TYPES.animateImage]: "video",
  [CREATIVE_JOB_TYPES.generateVideo]: "video",
  [CREATIVE_JOB_TYPES.generateRecommendedSettingsPlatform]: "ai",
  [CREATIVE_JOB_TYPES.generateCustomReport]: "ai",
  [CREATIVE_JOB_TYPES.analyzeImageLayers]: "image",
  [CREATIVE_JOB_TYPES.analyzeCreativeTemplate]: "image",
  [CREATIVE_JOB_TYPES.produceCreativeTemplate]: "image",
};

const CATEGORY_UNEXPECTED_KEYS = {
  image: CREATIVE_UNEXPECTED_IMAGE_PROVIDER_ERROR,
  video: CREATIVE_UNEXPECTED_VIDEO_PROVIDER_ERROR,
  ai: CREATIVE_UNEXPECTED_AI_PROVIDER_ERROR,
};

const CATEGORY_TIMEOUT_KEYS = {
  image: CREATIVE_TIMEOUT_IMAGE_PROVIDER_ERROR,
  video: CREATIVE_TIMEOUT_VIDEO_PROVIDER_ERROR,
  ai: CREATIVE_TIMEOUT_AI_PROVIDER_ERROR,
};

const TIMEOUT_ERROR_CODES = new Set([
  TIME_OUT_FOR_PROVIDER,
  AI_REQUEST_TIMEOUT,
]);

const NO_CREDITS_SUFFIX_CODES = new Set([
  NOT_HAVE_ENOUGH_USAGE_VALUE,
  AI_PROVIDER_CREDENTIALS_INVALID,
  FAL_AI_CREDENTIALS_INVALID,
  HEYGEN_CREDENTIALS_INVALID,
  MISSING_PARAMETERS,
  INVALID_JOB_TYPE,
  JOB_CANCELLED_OR_FAILED,
  JOB_TIMEOUT,
  CUSTOM_REPORT_NO_ACTIVE_CAMPAIGNS_IN_PERIOD,
  CAMPAIGN_IS_GENERATING,
  INTEGRATION_INFORMATION_NOT_FOUND,
  ERROR_GETTING_URL_META_DATA_AND_IMAGES,
  ERROR_OCCURRED,
  META_INTEGRATION_UNLINKED_PAGES_ERROR,
  PERMISSIONS_OR_CONFIGURATION_ACCOUNT_CHANGE_META,
  META_ERROR_GETTING_USER_INFORMATION,
  META_ERROR_GETTING_BUSINESS_ACCOUNTS_INFORMATION,
  META_ERROR_GETTING_ACCOUNTS_INFORMATION,
  FACEBOOK_PAGE_ID_NOT_FOUND,
  META_BUSINESS_ACCOUNT_NOT_FOUND,
  IG_BUSINESS_ACCOUNT_NOT_FOUND,
  ACCOUNT_TIKTOK_AUTH_NOT_MATCH,
  ACCOUNT_TOKEN_META_NOT_FOUND,
  ACCOUNT_ID_BUSINESS_META_NOT_FOUND,
  ADVERTISER_ID_NOT_FOUND_TIK_TOK,
  ADVERTISER_ID_NOT_FOUND_GOOGLE,
  ERROR_CREATING_INSTANT_EXPERIENCE,
  CAMPAIGN_REQUEST_ABORTED,
  APP_URL_NOT_FOUND,
  INVALID_APP_DEEP_LINK,
  BENEFICIARY_OR_PAYER_NOT_FOUND,
  META_OAUTH_PERMISSIONS_ERROR,
  META_ACCOUNT_AUTHENTICATION_REQUIRED,
  DELETE_OPERATION_NOT_ALLOWED_FOR_CAMPAIGN,
  RATE_DAILY_LIMIT_AI,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_INVALID,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_WIDTH_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_HEIGHT_NOT_MULTIPLE_OF_16,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_ASPECT_RATIO_EXCEEDED,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS,
  IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS,
]);

const CREATIVE_LEGACY_PIPELINE_CODES = new Set([
  "ALL_IMAGES_FAILED",
  "IMAGE_GENERATION_ERROR",
  "GENERATION_FAILED",
  "IMAGE_EDIT_ERROR",
  "VIDEO_GENERATION_FAILED",
  "VIDEO_GENERATION_ERROR",
  "IMAGE_ANIMATION_ERROR",
  "IMAGE_RESIZING_GENERATE_REST_NO_SUCCESSFUL_RESULTS",
  "IMAGE_RESIZING_GENERATE_REST_INPUT_ERROR",
  "MISSING_IMAGE_URL",
]);

const RAW_MESSAGE_PATTERNS = [
  /^failed to generate/i,
  /^failed to generate any images/i,
  /^generation failed/i,
  /^creative job timeout$/i,
  /^no image url available$/i,
  /^no successful results$/i,
  /^all resized images failed validation$/i,
];

const isRawOrUnmappedCreativeError = ({ code, message, translated }) => {
  if (!code) {
    return true;
  }
  if (CREATIVE_LEGACY_PIPELINE_CODES.has(code)) {
    return true;
  }
  if (translated === code) {
    return true;
  }
  if (
    typeof message === "string" &&
    RAW_MESSAGE_PATTERNS.some((pattern) => pattern.test(message.trim()))
  ) {
    return true;
  }
  return false;
};

const getCreativeJobCategory = (jobType) =>
  CREATIVE_JOB_CATEGORY[jobType] || "ai";

const shouldAppendCreditsSuffix = (code, paymentMode) => {
  if (paymentMode === "byok") {
    return false;
  }
  if (!code || NO_CREDITS_SUFFIX_CODES.has(code)) {
    return false;
  }
  if (isAiProviderCredentialsInvalidCode(code)) {
    return false;
  }
  return true;
};

const resolveCreativeJobBaseMessage = ({
  code,
  category,
  formatted,
  providerInterpolation,
  t,
}) => {
  if (code && TIMEOUT_ERROR_CODES.has(code)) {
    return t(CATEGORY_TIMEOUT_KEYS[category]);
  }

  const translated = code ? errorCodeToText(code, providerInterpolation) : null;

  if (
    isRawOrUnmappedCreativeError({
      code,
      message: formatted?.message,
      translated,
    })
  ) {
    return t(CATEGORY_UNEXPECTED_KEYS[category]);
  }

  if (typeof formatted?.message === "string" && formatted.message.trim()) {
    return formatted.message.trim();
  }

  if (translated && translated !== code) {
    return translated;
  }

  return t(CATEGORY_UNEXPECTED_KEYS[category]);
};

/**
 * Resolves user-facing error copy for credit-based creative jobs.
 * Composes base AI-provider messaging with an optional credits-refund suffix.
 */
export const resolveCreativeJobErrorMessage = ({
  jobType,
  errorOrResponse,
  paymentMode = "credits",
  t = (key) => i18next.t(key),
}) => {
  const category = getCreativeJobCategory(jobType);
  const formatted =
    errorOrResponse?.ok === false && errorOrResponse?.code != null
      ? errorOrResponse
      : getObjectError(errorOrResponse);

  const { code, provider, paymentMode: errorPaymentMode } = formatted || {};
  const effectivePaymentMode = errorPaymentMode || paymentMode;
  const providerInterpolation = getProviderInterpolationForError(
    code,
    provider || formatted?.provider
  );

  const baseMessage = resolveCreativeJobBaseMessage({
    code,
    category,
    formatted,
    providerInterpolation,
    t,
  });

  const creditsSuffix = t(CREDITS_RETURNED_SUFFIX);
  const normalizedBase = baseMessage.includes(creditsSuffix)
    ? baseMessage.replace(` ${creditsSuffix}`, "").trim()
    : baseMessage;

  if (!shouldAppendCreditsSuffix(code, effectivePaymentMode)) {
    return normalizedBase;
  }

  return `${normalizedBase} ${creditsSuffix}`;
};

/**
 * AI action errors: generic copy for credits; provider-specific copy in BYOK mode.
 */
export const resolveChatAgentErrorMessage = ({
  errorOrResponse,
  paymentMode = "credits",
  creditsMessageKey = ERROR_OCCURRED,
  t = (key) => i18next.t(key),
}) => {
  const effectivePaymentMode = errorOrResponse?.paymentMode || paymentMode;

  if (effectivePaymentMode !== "byok") {
    return t(creditsMessageKey);
  }

  if (errorOrResponse == null || errorOrResponse === false) {
    return t(creditsMessageKey);
  }

  const formatted =
    errorOrResponse?.ok === false && errorOrResponse?.code != null
      ? errorOrResponse
      : getObjectError(errorOrResponse);

  const { message, code } = formatted || {};
  if (typeof message === "string" && message.trim()) {
    return message.trim();
  }

  if (code) {
    const providerId =
      formatted?.provider ||
      formatted?.data?.provider ||
      errorOrResponse?.response?.data?.provider;
    const translated = errorCodeToText(
      code,
      getProviderInterpolationForError(code, providerId)
    );
    if (translated && translated !== code) {
      return translated;
    }
  }

  return t(ERROR_OCCURRED);
};

const isAiProviderCredentialsInvalidCode = (errorCode) =>
  errorCode === AI_PROVIDER_CREDENTIALS_INVALID ||
  errorCode === FAL_AI_CREDENTIALS_INVALID ||
  errorCode === HEYGEN_CREDENTIALS_INVALID ||
  errorsObject[errorCode] === AI_PROVIDER_CREDENTIALS_INVALID;

const RESIZE_CUSTOM_DIMENSIONS_INTERPOLATION_BY_CODE = {
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_MAX_EDGE_EXCEEDED]: {
    max: RESIZE_MAX_EDGE,
  },
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_FEW_PIXELS]: {
    min: RESIZE_MIN_PIXELS,
  },
  [IMAGE_RESIZING_CUSTOM_DIMENSIONS_TOO_MANY_PIXELS]: {
    max: RESIZE_MAX_PIXELS,
  },
};

export const errorCodeToText = (errorCode, interpolation) => {
  const interpolationWithBusiness = {
    NAME_BUSINESS: globalThis.NAME_BUSINESS || "",
    ...RESIZE_CUSTOM_DIMENSIONS_INTERPOLATION_BY_CODE[errorCode],
    ...interpolation,
  };

  if (
    isAiProviderCredentialsInvalidCode(errorCode) &&
    !interpolationWithBusiness?.provider
  ) {
    return i18next.t(AI_PROVIDER_CREDENTIALS_INVALID_GENERIC);
  }

  if (errorsObject[errorCode]) {
    return i18next.t(errorsObject[errorCode], interpolationWithBusiness);
  } else if (errorsActivateShop[errorCode]) {
    return i18next.t(errorsActivateShop[errorCode], interpolationWithBusiness);
  } else {
    return errorCode;
  }
};

export const errorsActivateShop = {
  nit: NIT_VALID,
  businessName: BUSINESS_NAME_VALID,
  brandName: BRAND_NAME_VALID,
  address: ADDRESS_VALID,
  category: CATEGORY_VALID,
  subCategories: SUBCATEGORIES_VALID,
  shortDescription: SHORT_DESCRIPTION_VALID,
  ordersMethods: ORDERS_METHODS_VALID,
  logoImg: LOGO_IMG_VALID,
  coverImg: COVER_IMG_VALID,
  schedule: SCHEDULE_VALID,
  stores: STORES_VALID,
  isPlanActive: IS_PLAN_ACTIVE_VALID,
  menus: MENUS_VALID,
  defaultPaymentMethod: DEFAULT_PAYMENT_METHOD_VALID,
  hasDebt: HAS_DEBT_VALID,
  subscriptionPlan: SUBSCRIPTION_PLAN_VALID,
};

export const verifyIsErrorPermissionDenied = (error) => (_, getState) => {
  const userID = getState()?.auth?.user?.uid;
  if (
    !userID &&
    (error.code === "permission-denied" ||
      error.message === "Permission denied" ||
      error.code === "PERMISSION_DENIED" ||
      error.message === "PERMISSION_DENIED: Permission denied")
  ) {
    return true;
  }
  return false;
};

export const getReactHookFormNestedError = (errors, path) => {
  const normalizedPath = path.replace(/\[(\d+)\]/g, ".$1");
  const parts = normalizedPath.split(".").filter(Boolean);
  return parts.reduce((acc, part) => acc && acc[part], errors);
};

export const getFirstNestedFieldErrorMessage = (fieldError) => {
  if (!fieldError) return undefined;
  if (typeof fieldError.message === "string" && fieldError.message) {
    return fieldError.message;
  }

  if (Array.isArray(fieldError)) {
    for (const item of fieldError) {
      const message = getFirstNestedFieldErrorMessage(item);
      if (message) return message;
    }
    return undefined;
  }

  if (typeof fieldError === "object") {
    for (const key of Object.keys(fieldError)) {
      const message = getFirstNestedFieldErrorMessage(fieldError[key]);
      if (message) return message;
    }
  }

  return undefined;
};

export const ERRORS_BILLING = [
  CREATE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  ACTIVE_ADS_CAMPAIGN_ACCOUNT_NO_HAVE_BALANCE,
  META_AD_ACCOUNT_HAVE_NOT_PAYMENT_METHOD,
];

// Helper centralizado para registrar errores en Sentry
const logErrorToSentry = ({
  errorFormatted,
  rawError,
  userID,
  functionName,
  context = {},
  tags = {},
  level = "error",
  capture = "message",
}) => {
  try {
    let eventName = functionName
      ? `Error on - ${functionName}`
      : errorFormatted?.message || "Unknown error";

    const isErrorCampaign = errorFormatted?.code === "errorProcessingCampaigns";
    if (isErrorCampaign) {
      eventName = `Error on - ${functionName} ${context?.campaignID ? `${context?.campaignID}` : ""}`;
    }

    Sentry.withScope((scope) => {
      scope.setLevel(level);
      scope.setTag("source", "LaunchError");
      if (functionName) scope.setTag("function", functionName);
      if (errorFormatted?.code)
        scope.setTag("code", String(errorFormatted.code));
      if (userID) scope.setTag("userID", String(userID));
      Object.entries(tags || {}).forEach(([k, v]) =>
        scope.setTag(k, String(v))
      );

      scope.setContext("error", {
        message: errorFormatted?.message || rawError?.message || "No message",
        code: errorFormatted?.code || rawError?.code || "generalError",
      });

      scope.setContext("context", {
        functionName: functionName || null,
        userID: userID || null,
        ...context,
      });

      const platformErrors = errorFormatted?.data?.errors;
      if (platformErrors && typeof platformErrors === "object") {
        const errorsMessagesPlatform = {};
        Object.keys(platformErrors).forEach((platform) => {
          errorsMessagesPlatform[platform] =
            `${platformErrors?.[platform]?.code || "generalError"}: ${
              platformErrors?.[platform]?.message || "No message"
            }`;
        });
        scope.setContext("platformErrors", {
          errors: errorsMessagesPlatform,
          affectedPlatforms: Object.keys(platformErrors),
        });
      }

      if (capture === "exception" && rawError instanceof Error) {
        Sentry.captureException(rawError, { captureContext: scope });
      } else {
        Sentry.captureMessage(eventName, level);
      }
    });
  } catch (error) {
    /* ignore sentry logging errors */
  }
};

export const LaunchError =
  (error, showAlert = true, ignoreAlertByErrors = [], sentryMeta = {}) =>
  (dispatch, getState) => {
    console.log(error);
    const errorFormatted = getObjectError(error);
    const userID = getState()?.auth?.user?.uid;

    const isErrorCampaign = errorFormatted?.code === "errorProcessingCampaigns";
    const isErrorNetwork = errorFormatted?.code === "ERR_NETWORK";

    const isPermissionDenied =
      error.code === "permission-denied" ||
      error.message === "Permission denied" ||
      error.code === "PERMISSION_DENIED" ||
      error.message === "PERMISSION_DENIED: Permission denied";

    if (isPermissionDenied) {
      return {
        ok: false,
        code: error.code,
        message: error.message,
      };
    }

    if (
      errorFormatted?.code === INTEGRATION_INFORMATION_NOT_FOUND &&
      !ignoreAlertByErrors.includes(errorFormatted.code)
    ) {
      const fromResponse = error?.response?.data?.failedIntegrations;
      const fromData = errorFormatted?.data?.failedIntegrations;
      const fromTop = error?.failedIntegrations;
      const failed =
        fromResponse ||
        fromData ||
        fromTop ||
        errorFormatted?.failedIntegrations;
      if (Array.isArray(failed) && failed.length > 0) {
        dispatch(openIntegrationNotFoundModalIfNeeded(failed));
        return {
          ...errorFormatted,
          ok: false,
        };
      }
    }

    if (errorFormatted?.code === NOT_HAVE_ENOUGH_USAGE_VALUE) {
      dispatch(setShowModalSelectSubscription(true));
    }

    if (errorFormatted?.code === NOT_HAVE_ENOUGH_BRAND_USAGE_VALUE) {
      if (showAlert && !ignoreAlertByErrors.includes(errorFormatted.code)) {
        dispatch(showBrandUsageLimitAlert());
      }
      return {
        ...errorFormatted,
        ok: false,
      };
    }

    if (!errorFormatted?.message && error?.message) {
      errorFormatted.message = error.message;
    }

    if (sentryMeta?.creativeJobType) {
      const paymentMode =
        sentryMeta?.paymentMode ||
        getState()?.payments?.byokConfigurationPublic?.defaultPaymentMode ||
        "credits";

      errorFormatted.message = resolveCreativeJobErrorMessage({
        jobType: sentryMeta.creativeJobType,
        errorOrResponse: errorFormatted,
        paymentMode,
      });
    } else if (sentryMeta?.resolvedMessage) {
      errorFormatted.message = sentryMeta.resolvedMessage;
    }

    if (!errorFormatted?.message) {
      return {
        ...errorFormatted,
        ok: false,
      };
    }

    if (
      !ignoreAlertByErrors.includes(errorFormatted.code) &&
      !isErrorNetwork &&
      sentryMeta?.skipSentry !== true
    ) {
      // Registro centralizado en Sentry
      logErrorToSentry({
        errorFormatted,
        rawError: error,
        userID,
        functionName: sentryMeta?.functionName,
        context: sentryMeta?.context,
        tags: sentryMeta?.tags,
        level: sentryMeta?.level || "error",
        capture: sentryMeta?.capture || "message",
      });
    }

    // Flag opcional para mostrar la alerta como advertencia (solo visual)
    const isWarning = sentryMeta?.isWarning === true;
    const titleKey = isWarning ? WARNING : ERROR;
    const iconType = isWarning ? ALERT_ICON_TYPE_INFO : ALERT_ICON_TYPE_ERROR;

    if (
      showAlert &&
      !ignoreAlertByErrors.includes(errorFormatted.code) &&
      !isErrorCampaign
    ) {
      SimpleAlert({
        title: i18next.t(titleKey),
        html: (
          <Typography
            variant="body1"
            sx={{
              fontFamily: FONT_FAMILY,
              "& *": {
                p: "revert",
                m: "revert",
                listStyle: "revert",
                textDecoration: "revert",
              },
            }}
            dangerouslySetInnerHTML={{
              __html:
                errorFormatted.message ||
                i18next.t(ERROR_DESCRIPTION_GENERIC, {
                  message: errorFormatted.message,
                  code: errorFormatted.code,
                }),
            }}
          />
        ),
        icon: iconType,
      });
    }

    return {
      ...errorFormatted,
      ok: false,
    };
  };
